// src/components/LoginModal.js
import React, { useState } from "react";
import { Modal, Input, Button } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import api from "../../utilis/api";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../redux/reducer/authSlice";
import { useNavigate } from "react-router-dom";

const LoginModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle login submission
  const handleLogin = async () => {
    const { email, password } = formData;

    if (!email || !password) {
      return toast.error("Please enter both email and password");
    }

    try {
      const res = await api.post("/user/login", { email, password });

      dispatch(
        loginSuccess({
          user: res.data.user,
          token: res.data.token,
          role: res.data.user.role, // corrected
        }),
      );

      toast.success("Logged in successfully!");
      navigate("/dashboard/student");
      setFormData({ email: "", password: "" });
      onClose();

      // Optional: redirect immediately after login
      // if (res.data.data.user.role === "teacher") {
      //   navigate("/dashboard/teacher");
      // } else {
      //   navigate("/dashboard/student");
      // }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Login failed");
    }
  };

  // Handle forgot password
  const handleForgotPassword = async () => {
    const { email } = formData;
    if (!email) {
      return toast.error("Please enter your email to reset password");
    }

    try {
      await axios.post(
        "http://localhost:5000/api/v1/user/forgot-password", // your forgot password API
        { email },
        { headers: { "Content-Type": "application/json" } },
      );

      toast.success("Password reset email sent! Check your inbox.");
    } catch (error) {
      console.log(error);
      toast.error(
        error.response?.data?.message || "Failed to send reset email",
      );
    }
  };

  return (
    <Modal
      title={
        <span
          style={{
            marginLeft: "1rem",
            color: "#e6be5d",
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          Login as a Student
        </span>
      }
      open={isOpen}
      onCancel={() => {
        setFormData({ email: "", password: "" });
        onClose();
      }}
      footer={null}
      className="custom-modal"
    >
      <div
        style={{
          background: "#000",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ color: "#fff" }}>Email</label>
          <Input
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="john@example.com"
            style={{
              borderRadius: "8px",
              padding: "10px 12px",
              border: "1px solid #d1d5db",
            }}
          />
        </div>

        <div style={{ marginBottom: "8px" }}>
          <label style={{ color: "#fff" }}>Password</label>
          <Input.Password
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••"
            style={{
              borderRadius: "8px",
              padding: "10px 12px",
              border: "1px solid #d1d5db",
            }}
          />
        </div>

        {/* Forgot Password Link */}
        <div style={{ textAlign: "right", marginBottom: "16px" }}>
          <button
            onClick={handleForgotPassword}
            style={{
              background: "transparent",
              border: "none",
              color: "#facc15",
              cursor: "pointer",
              fontSize: "14px",
              padding: 0,
            }}
          >
            Forgot Password?
          </button>
        </div>

        <Button
          type="primary"
          block
          style={{
            marginTop: "10px",
            background: "linear-gradient(to right, #fef3c7, #facc15, #fef3c7)",
            border: "none",
            color: "#1f2937",
            fontWeight: "600",
            height: "48px",
            borderRadius: "8px",
          }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </div>
    </Modal>
  );
};

export default LoginModal;
